/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { XdaStringsService } from '../../services/xda-strings.service';
import { AccountService } from '../../services/account.service';
import { AccessListService } from '../../services/access-list.service';
import { AppsService } from '../../services/apps.service';
import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'tos-update-modal-component',
  templateUrl: './tos-update-modal.component.html',
  styleUrls: ['./tos-update-modal.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TosUpdateModalComponent implements OnInit {
  @Input() public neededTos: string[];
  @Input() public email: string;
  @Input() public userId: string;
  @Input() public guestEula: boolean;

  public tosPages: TosPage[];
  public currentPage: TosPage;
  public currentPageNum = 0;
  public totalPages = 0;
  eulaString: string;
  nextButtonText: string;

  constructor(
    public activeModal: NgbActiveModal,
    private errorService: ErrorService,
    private xdaStringsService: XdaStringsService,
    private accountService: AccountService,
    private accessListService: AccessListService,
    private appsService: AppsService,
  ) {
    this.tosPages = [];
  }

  async ngOnInit() {
    await this.xdaStringsService.getAGEulas();
    if (this.neededTos.includes('eula_not_accepted')) {
      await this.getTOU();
    }

    if (this.neededTos.includes('StandardTOS')) {
      this.tosPages.push({
        title: 'SDE_TERMS_SERVICE_UPDATED',
        desc: 'SDE_TERMS_SERVICE_HAVE',
        text: this.xdaStringsService.eulas['termsOfService'],
        accepted: false,
      });
    }
    if (this.neededTos.includes('AdminTOS')) {
      this.tosPages.push({
        title: 'SDE_DATA_ADMINISTRATION_TERMS',
        desc: 'SDE_DATA_ADMINISTRATION_TERMS1',
        text: this.xdaStringsService.eulas['adminTermsOfService'],
        accepted: false,
      });
    }
    if (this.neededTos.includes('DeveloperTOS')) {
      this.tosPages.push({
        title: 'SDE_DEVELOPER_TERMS_SERVICE',
        desc: 'SDE_DEVELOPER_TERMS_SERVICE2',
        text: this.xdaStringsService.eulas['devTermsOfService'],
        accepted: false,
      });
    }
    if (this.neededTos.includes('eula_not_accepted')) {
      this.tosPages.push({
        title: 'SDE_LICENSE_AGREEMENT1',
        desc: 'Xerox ' + this.xdaStringsService.strings['APPNAME'],
        text: this.eulaString,
        accepted: false,
        isHTML: true,
      });
    }
    this.currentPage = this.tosPages[0];
    this.currentPageNum = 1;
    this.totalPages = this.tosPages.length;
    this.nextButtonText =
      this.currentPageNum === this.totalPages ? 'SDE_DONE' : 'SDE_NEXT';
    if (this.guestEula) {
      this.currentPage.accepted = true;
      this.nextButtonText = 'SDE_AGREE1';
    }
  }

  getPageOfText() {
    return this.xdaStringsService.strings['SDE_FMTSTR_OF_FMTSTR']
      .replace('{0}', this.currentPageNum.toString())
      .replace('{1}', this.totalPages.toString());
  }

  next() {
    if (this.currentPageNum === this.totalPages) {
      // If this is the guest eula, just close it, we do not need to "save" the fact it was accepted
      if (this.guestEula) {
        this.activeModal.close();
      } else if (this.neededTos.includes('eula_not_accepted')) {
        this.accessListService.updateEula(this.userId).subscribe(
          () => {
            this.activeModal.close();
          },
          (err) => {
            console.error('acceptEULA -- Error', err);
            this.errorService.displayGeneralError();
          },
        );
      } else {
        this.accountService
          .acceptNeededTos(this.email, this.neededTos)
          .subscribe(
            () => {
              this.activeModal.close();
            },
            (err) => {
              console.error('acceptNeededTos -- Error', err);
              this.errorService.displayGeneralError();
            },
          );
      }
    } else {
      this.currentPage = this.tosPages[this.currentPageNum++];
    }
    this.nextButtonText =
      this.currentPageNum === this.totalPages ? 'SDE_DONE' : 'SDE_NEXT';
  }

  async getTOU() {
    await this.appsService
      .getTOU(this.userId)
      .then((resp) => {
        this.eulaString = resp;
      })
      .catch((err) => console.log(err));
  }
}

interface TosPage {
  title: string;
  desc: string;
  text: string;
  accepted: boolean;
  isHTML?: boolean;
}
